import { Component, OnChanges, Input, Output, EventEmitter, ElementRef } from '@angular/core';

import { Global } from '../../../../app.global';
import { Constants } from '../../helper/constants';
import { slideToggle } from '../../../../app.animations';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'checkbox-select',
  templateUrl: './checkbox-select.component.html',
  styleUrls: ['./checkbox-select.component.scss'],
  animations: [slideToggle],
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {
    '(document:click)': 'onDocumentClick($event)',
  },
})
export class CheckboxSelectComponent implements OnChanges {
  @Input() options: any;
  @Input() selectedOptions: any;
  @Output() selectOption: EventEmitter<any> = new EventEmitter<any>();

  constants = Constants;
  isOptionsSectionVisible = false;
  inputValue = '';

  constructor(public global: Global, private _eref: ElementRef) {}

  // ngOnInit() {
  //   this.options = this.addDefaultOption(this.options);
  //   this.setSelectedOptions();
  //   this.setInputValue();
  // }

  ngOnChanges() {
    if (this.options[0].id !== -1) {
      this.options = this.addDefaultOption(this.options);
      this.setSelectedOptions();
      this.setInputValue();
    }
    this.setInputValue();
  }

  addDefaultOption(list) {
    let newList = [];
    const defaultOption = {
      id: -1,
      text: 'Check all',
    };
    newList.push(defaultOption);
    newList = newList.concat(list);
    return newList;
  }

  setSelectedOptions() {
    if (this.isAlloptionsOptionSelected()) {
      this.selectedOptions = [];
      this.options.forEach((option) => {
        this.selectedOptions.push(option.id);
      });
    }
  }

  setInputValue() {
    if (this.isAlloptionsOptionSelected()) {
      this.inputValue = 'All items checked';
    } else if (this.selectedOptions.length === 0) {
      this.inputValue = 'Please check an item';
    } else if (this.selectedOptions.length < 3) {
      this.inputValue = '';
      this.selectedOptions.forEach((selectedOption) => {
        if (this.inputValue.length > 0) {
          this.inputValue += ', ';
        }
        this.options.forEach((option) => {
          if (selectedOption === option.id) {
            this.inputValue += option.text;
          }
        });
      });
    } else {
      this.inputValue = `${this.selectedOptions.length} items checked`;
    }
  }

  isAlloptionsOptionSelected() {
    const optionsIds = [];
    this.selectedOptions.forEach((option) => {
      optionsIds.push(option);
    });
    return optionsIds.indexOf(-1) > -1;
  }

  onOptionSelected(option) {
    this.checkOptions(option);

    this.selectOption.emit(this.selectedOptions);

    this.setInputValue();
  }

  checkOptions(option) {
    if (option.id === -1 && !this.isOptionSelected(option)) {
      this.selectedOptions = [];
      this.options.forEach((opt) => {
        this.selectedOptions.push(opt.id);
      });
      this.selectedOptions = this.selectedOptions.slice();
    } else if (option.id === -1 && this.isOptionSelected(option)) {
      this.selectedOptions = [];
    } else if (!this.isOptionSelected(option)) {
      this.selectedOptions.push(option.id);
    } else if (this.isOptionSelected(option)) {
      const index = this.selectedOptions.indexOf(option.id);
      this.selectedOptions.splice(index, 1);
    }
    this.updateDefaultOption();
  }

  updateDefaultOption() {
    let allOptionsChecked = true;
    this.options.forEach((option) => {
      if (this.selectedOptions.indexOf(option.id) === -1) {
        if (option.id !== -1) {
          allOptionsChecked = false;
        }
      }
    });

    if (!allOptionsChecked) {
      const index = this.selectedOptions.indexOf(-1);
      if (index > -1) {
        this.selectedOptions.splice(index, 1);
      }
    } else {
      const index = this.selectedOptions.indexOf(-1);
      if (index === -1) {
        this.selectedOptions.push(-1);
      }
    }
  }

  isOptionSelected(option) {
    return this.selectedOptions.indexOf(option.id) > -1;
  }

  toggleOptionsSection(event) {
    this.isOptionsSectionVisible = !this.isOptionsSectionVisible;
  }

  // global event
  onDocumentClick(event) {
    if (!this._eref.nativeElement.contains(event.target)) {
      this.isOptionsSectionVisible = false;
    }
  }
}
